var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form-item',{attrs:{"label":_vm.$t('单据编码')}},[_c('l-select',{attrs:{"placeholder":_vm.$t('请选择'),"size":"mini","options":_vm.codeList},model:{value:(_vm.data.code),callback:function ($$v) {_vm.$set(_vm.data, "code", $$v)},expression:"data.code"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }